import { HierarchyScrollPositionStore } from '@stores/paginated-hierarchy-items/HierarchyScrollPositionStore'
import { TableElementRefStore } from './TableElementRefStore'

export default class PaginatedTableHierarchyScrollPositionStore extends HierarchyScrollPositionStore {
  scrollToColIndex = (colIndex: number) => {
    if (
      !(this.elementRefStore as TableElementRefStore).tableRef.isColumnVisible(colIndex)
    ) {
      ;(this.elementRefStore as TableElementRefStore).tableRef.scrollToColumn(colIndex)
    }
  }
}
